<template>
  <div class="container-fluid">
    <div class="row mb-3 align-items-center">
      <div class="col">
        <h4 class="mb-1">Bono conductor</h4>
        <p class="text-muted mb-0">
          Metas de viajes en un rango de fechas. Si el conductor completa la meta a tiempo,
          el bono suma al depósito del corte semanal (tarjeta + bono − deuda). El efectivo
          ya lo tiene el conductor; si no completa a tiempo, no se acredita nada.
        </p>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary" @click="goCreate">Nueva bonificación</button>
      </div>
    </div>

    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
    <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-5 text-muted">Cargando…</div>
        <div v-else class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th>Título</th>
                <th>Viajes meta</th>
                <th>Bono (CLP)</th>
                <th>Desde</th>
                <th>Hasta</th>
                <th>Conductores</th>
                <th>Estado</th>
                <th class="text-right">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rows" :key="row.id">
                <td>
                  <strong>{{ row.title }}</strong>
                  <div v-if="row.description" class="small text-muted">{{ row.description }}</div>
                </td>
                <td>{{ row.targetTrips }}</td>
                <td>${{ formatMoney(row.rewardAmount) }}</td>
                <td>{{ formatDate(row.startsAt) }}</td>
                <td>{{ formatDate(row.endsAt) }}</td>
                <td>{{ row.driversInProgress ?? 0 }}</td>
                <td>
                  <span :class="row.isActive ? 'badge badge-success' : 'badge badge-secondary'">
                    {{ row.isActive ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
                <td class="text-right text-nowrap">
                  <button class="btn btn-sm btn-outline-primary mr-1" @click="goEdit(row)">
                    Editar
                  </button>
                  <button class="btn btn-sm btn-outline-danger" @click="confirmDelete(row)">
                    Eliminar
                  </button>
                </td>
              </tr>
              <tr v-if="!rows.length">
                <td colspan="8" class="text-center text-muted py-4">
                  No hay bonificaciones de conductor.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { deleteDriverBono, fetchDriverBonos } from '@/services/driverBonosApi';

export default {
  name: 'BonoConductorPage',
  data() {
    return {
      loading: true,
      rows: [],
      errorMessage: '',
      successMessage: '',
    };
  },
  created() {
    if (this.$route.query.saved) {
      this.successMessage = 'Bonificación guardada correctamente';
    }
    this.load();
  },
  methods: {
    formatDate(iso) {
      if (!iso) return '—';
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return '—';
      return d.toLocaleString('es-CL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    formatMoney(n) {
      return Number(n || 0).toLocaleString('es-CL');
    },
    async load() {
      this.loading = true;
      this.errorMessage = '';
      try {
        this.rows = await fetchDriverBonos();
      } catch (e) {
        this.rows = [];
        this.errorMessage = e.message || 'No se pudieron cargar las bonificaciones';
      } finally {
        this.loading = false;
      }
    },
    goCreate() {
      this.$router.push({ name: 'bono-conductor-nuevo' });
    },
    goEdit(row) {
      this.$router.push({ name: 'bono-conductor-editar', params: { id: row.id } });
    },
    async confirmDelete(row) {
      const result = await Swal.fire({
        title: '¿Eliminar bonificación?',
        text: row.title,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });
      if (!result.isConfirmed) return;
      try {
        await deleteDriverBono(row.id);
        this.successMessage = 'Bonificación eliminada';
        await this.load();
      } catch (e) {
        this.errorMessage = e.message || 'No se pudo eliminar';
      }
    },
  },
};
</script>
